import * as React from "react";
import { useMemo } from "react";
import styled from "styled-components";
import { Spinner } from "components/common";
import { DataWell, Col } from "common/components";
import PackRecsAndDeps from "../PackRecsAndDeps";
import { useGetRequirements } from "../utils";
const Description = styled.p`
  white-space: pre-wrap;
`;
function ExpandedPackDetails({ pack }) {
  const { fetchingAllPacks, getRequiredPacks, getRequiredByPacks } = useGetRequirements();
  const requiredPacks = useMemo(() => getRequiredPacks(pack), [pack, getRequiredPacks]);
  const requiredByPacks = useMemo(() => getRequiredByPacks(pack), [pack, getRequiredByPacks]);
  const showRequirements = useMemo(
    () => requiredPacks.length > 0 || requiredByPacks.length > 0 || !pack.is_compatible && pack.version_requirements.length > 0,
    [requiredPacks, requiredByPacks, pack]
  );
  return fetchingAllPacks ? /* @__PURE__ */ React.createElement(Spinner, { text: "Fetching details" }) : /* @__PURE__ */ React.createElement(Col, { $gap: "xxs", $align: "stretch" }, /* @__PURE__ */ React.createElement(DataWell, null, /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement("strong", null, "Description:"), /* @__PURE__ */ React.createElement(Description, null, pack.description))), showRequirements && /* @__PURE__ */ React.createElement(DataWell, null, /* @__PURE__ */ React.createElement(
    PackRecsAndDeps,
    {
      requiredByPacks,
      dependsOnPacks: requiredPacks,
      requiredVersions: pack.is_compatible ? [] : pack.version_requirements
    }
  )));
}
export default ExpandedPackDetails;
